import React from 'react';

/* Components */
import ProductOverviewFilter from './ProductOverviewFilter';

/* Common */
import { SelectDropdown } from '~/components/common';
import { Button, Modal } from '~/components/common';

/* Utilities */
import { trans } from '~/utilities';

export default function ProductOverviewHeader({
    filters,
    sorting,
    modalOpen,
    setModalOpen,
    isLoading,
    resetAllFilters,
    updateSorting,
    isDesktop,
    isSticky,
    totalResults,
    updateFilters,
    handleResetFilter,
    filtersShowAll,
    setFiltersShowAll
}) {
    return (
        <>
            <Modal
                open={modalOpen}
                handleClose={() => setModalOpen(false)}
                backText={trans('app.content_block.vehicles.filter.options.modal_back')}
                modalTitle='Filteren'
                modalBody={
                    <>
                        <div className="mb-20 mx-n2">
                            <div className="d-flex align-items-center justify-content-between mb-4">
                                <span className="font-weight-bold text--14">{trans('app.vehicle_overview.filtered_title')}</span>
                                <Button
                                    title={trans('app.vehicle_overview.reset_filters')}
                                    theme="secondary"
                                    className="btn-sm btn-inline-block text-base flex-row-reverse"
                                    onClick={() => resetAllFilters()}
                                />
                            </div>
                            <ProductOverviewFilter
                                id="modalFilter"
                                filters={filters}
                                updateFilters={updateFilters}
                                handleResetFilter={handleResetFilter}
                                filtersShowAll={filtersShowAll}
                                setFiltersShowAll={setFiltersShowAll}
                            />
                        </div>
                        <div className="filter-button-fixed">
                            <Button
                                title={trans('app.vehicle_overview.result_button', { 'result': totalResults})}
                                theme="primary"
                                className={`btn-block justify-content-between ${ isLoading ? 'btn--loader' : '' }`.trim()}
                                onClick={() => setModalOpen(false)}
                            />
                        </div>
                    </>
                }
            />

            <div className="row gutters-0 gutters-lg-4 justify-content-between align-items-center mb-2 mb-lg-4">
                {isDesktop && (
                    <div className="col-auto">
                        <div className="d-flex align-items-center gap-4">
                            <div className="no-wrap">{trans('app.vehicle_overview.result', { 'result': totalResults})}</div>

                            <Button
                                title={trans('app.vehicle_overview.reset_filters')}
                                theme="secondary"
                                className="btn-sm btn-block"
                                onClick={() => resetAllFilters()}
                            />
                        </div>
                    </div>
                )}
                <div className="col-12 col-lg-3 col-xxl-auto">
                    <div className="row gutters-4">
                        {!isDesktop && (
                            <div className="col-6 col-lg-12">
                                <Button
                                    title={trans('app.vehicle_overview.filter_button')}
                                    theme="primary"
                                    className="btn-block justify-content-between mb-3"
                                    onClick={() => setModalOpen(true)}
                                />
                            </div>
                        )}
                        <div className="col-6 col-lg-12">
                            <SelectDropdown
                                id="filter-sorting"
                                className="custom-select no-border"
                                name="sort"
                                emptyValueLabel="Sorteren"
                                options={sorting}
                                onChange={(options) => {
                                    updateSorting(options);
                                }}
                            />
                        </div>
                    </div>
                </div>
                {!isDesktop && (
                    <div className="col-12 d-lg-none">
                        <ProductOverviewFilter
                            filters={filters}
                            isSticky={isSticky}
                            isDesktop={false}
                            horizontal={true}
                            updateFilters={updateFilters}
                            handleResetFilter={handleResetFilter}
                            filtersShowAll={filtersShowAll}
                            setFiltersShowAll={setFiltersShowAll}
                        />
                        <div className="no-wrap">{trans('app.vehicle_overview.result', {'result': totalResults})}</div>
                    </div>
                )}
            </div>
        </>
    );
}
